/**
 * @generated SignedSource<<9964dd874df6ecb380f9192a36e88a53>>
 * @relayHash e07f74cec024207b689b15170e612af8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ef30b6ec40fff3da836e0958ec8dcf30b34bcfc376bd76aef387674cb16cfd8

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIssueSearchHierarchyEnabledInput = {
  hierarchyEnabled: boolean;
  viewId: string;
};
export type HierarchyToggle876BadPatternMutation$variables = {
  input: JiraSetIssueSearchHierarchyEnabledInput;
};
export type HierarchyToggle876BadPatternMutation$data = {
  readonly jira_setIssueSearchHierarchyEnabled: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type HierarchyToggle876BadPatternMutation = {
  response: HierarchyToggle876BadPatternMutation$data;
  variables: HierarchyToggle876BadPatternMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JiraSetIssueSearchHierarchyEnabledPayload",
    "kind": "LinkedField",
    "name": "jira_setIssueSearchHierarchyEnabled",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HierarchyToggle876BadPatternMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HierarchyToggle876BadPatternMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3ef30b6ec40fff3da836e0958ec8dcf30b34bcfc376bd76aef387674cb16cfd8",
    "metadata": {},
    "name": "HierarchyToggle876BadPatternMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1b02bec6e4804f4d21a2c96557b7366f";

export default node;
